import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import { AdminPages } from '../AdminPages';
import Enum from '../../../utilities/Enum';

export const AGENT_STATUS_RUNNING = 'Running';
export const AGENT_STATUS_DISABLED = 'Disabled';
export const AGENT_STATUS_UPDATE = 'Updating';
export const AGENT_STATUS_RESTART = 'Restarting';
export const AGENT_STATUS_FORCE_UPDATE = 'F';
export const AGENT_STATUS_DELETED = 'Deleted';
export const AGENT_STATUS_UNCLAIMED = 'Unclaimed';
export const AGENT_STATUS_DOWN = 'Offline';
export const AGENT_STATUS_ENABLING = 'Enabling';
export const AGENT_STATUS_MOVE = 'Moving';

export const AGENT_NAME_FIELD = 'name';
export const AGENT_NAME_MAX_LENGTH = 64;
export const AGENT_STATUS_FIELD = 'status';
export const AGENT_TYPE_FIELD = 'type';
export const AGENT_TYPE_ICON_FIELD = 'typeIcon';
export const AGENT_DESCRIPTION_FIELD = 'description';
export const AGENT_LOCATION_FIELD = 'location';
export const AGENT_CONTACT_FIELD = 'contact';
export const AGENT_TRANSLATED_TYPE_FIELD = 'translatedType';
export const AGENT_MODEL_SHORT_FIELD = 'modelShort';
export const AGENT_MODEL_SHORT_DISPLAY_FIELD = 'modelShortDisplay';
export const AGENT_MODEL_LONG_DISPLAY_FIELD = 'modelLongDisplay';
export const AGENT_MODEL_LONG_FIELD = 'modelLong';
export const AGENT_EDGE_SENSOR_MODEL_FIELD = 'edgeSensorModel';
export const AGENT_SSID_FIELD = 'ssid';
export const AGENT_BSSID_FIELD = 'bssid';
export const AGENT_NETWORK_BSSID_FIELD = 'networkBSSID';
export const AGENT_NETWORK_SSID_FIELD = 'networkSSID';
export const AGENT_WIFI_SSID_FIELD = 'wifiSsid';
export const AGENT_WIFI_TECHNOLOGY_FIELD = 'wifiTechnology';
export const AGENT_WIFI_DEVICE_FIELD = 'device';
export const AGENT_WIFI_DEVICE_NAME_FIELD = 'deviceName';
export const AGENT_WIFI_RADIO_FIELD = 'radio';
export const AGENT_WIFI_RADIO_NAME_FIELD = 'radioName';
export const AGENT_WIFI_BSSID_FIELD = 'wifiBssid';
export const AGENT_WIFI_CHANNEL_FIELD = 'wifiChannel';
export const AGENT_WIFI_CHANNEL_WIDTH_FIELD = 'wifiChannelWidth';
export const AGENT_WIFI_CHANNEL_FREQUENCY_FIELD = 'wifiFrequency';
export const AGENT_WIFI_ERRORS_FIELD = 'wifiErrors';
export const AGENT_WIFI_SIGNAL_LEVEL_FIELD = 'wifiSignalLevelDbm';
export const AGENT_IS_WIRELESS_ENABLED_FIELD = 'isWirelessEnabled';
export const AGENT_IS_DYNAMIC_WIRELESS_ENABLED_FIELD = 'isDynamicWirelessEnabled';
export const AGENT_WIFI_CONNECTED_FIELD = 'wifiConnected';
export const AGENT_WIRED_FIELD = 'wired';
export const AGENT_WIFI_AUTUTHENTICATION_FIELD = 'wifiAuthentication';
export const AGENT_WIFI_CIPHER_FIELD = 'wifiCipher';
export const AGENT_WIRED_ERRORS_FIELD = 'wiredErrors';
export const AGENT_WIRED_CONNECTED_FIELD = 'wiredConnected';
export const AGENT_REQUIRES_UPDATE = 'requiresUpdate';
export const AGENT_RECOMMENDED_UPDATE = 'recommendedUpdate';
export const AGENT_REPORTED_NETWORK_ADAPTERS = 'network.reportedInterfaces.interfaces';
export const AGENT_LATEST_AGENT_VERSION = 'latestAgentVersion';
export const AGENT_NETWORK_HOSTNAME_FIELD = 'network.hostname';
export const AGENT_NETWORK_IPV4_LOCAL_FIELD = 'network.ipv4Local';
export const AGENT_NETWORK_IPV6_LOCAL_FIELD = 'network.ipv6Local';
export const AGENT_NETWORK_IPV4_INTERNAL_SORT_FIELD = 'ipv4LocalInternal';
export const AGENT_NETWORK_IPV6_INTERNAL_SORT_FIELD = 'ipv6LocalInternal';
export const AGENT_NETWORK_IPV4_EXTERNAL_FIELD = 'network.ipv4External';
export const AGENT_NETWORK_IPV4_EXTERNAL_SORT_FIELD = 'ipv4LocalExternal';
export const AGENT_NETWORK_IPV6_EXTERNAL_FIELD = 'network.ipv6External';
export const AGENT_NETWORK_IP_EXTERNAL_SORT_FIELD = 'ipExternalSort';
export const AGENT_NETWORK_IP_EXTERNAL_FIELD = 'network.ipExternal';
export const AGENT_NETWORK_IP_CLASS_FIELD = 'network.ipClass';
export const AGENT_NETWORK_WIFI_MAC_FIELD = 'network.wifiMac';
export const AGENT_NETWORK_MAC_FIELD = 'network.mac';
export const AGENT_SERIAL_NUMBER = 'vitals.serial_number';
export const AGENT_TAGS_FIELD = 'tags';
export const AGENT_TAGS_DISPLAY_FIELD = 'tagsDisplay';
export const AGENT_BULK_XMS_HOST_FIELD = 'serverUrl';
export const AGENT_ALLOW_REBOOT = 'allowReboot';
export const AGENT_SOFTWARE_VERSION_FIELD = 'version.softwareVersion';
export const AGENT_OS_NAME_FIELD = 'version.osName';
export const AGENT_OS_VERSION_FIELD = 'version.osVersion';
export const AGENT_FIRMWARE_VERSION_FIELD = 'version.firmwareVersion';
export const AGENT_TRANSLATED_WEB_PROXY_FIELD = 'translatedWebProxy';
export const AGENT_NEAREST_SWITCH_FIELD = 'nearestSwitch';
export const AGENT_NEAREST_SWITCH_IP_FIELD = 'nearestSwitchIP';
export const AGENT_NEAREST_SWITCH_IP_SORT_FIELD = 'nearestSwitchIPSort';
export const AGENT_NEAREST_SWITCH_PORT_FIELD = 'nearestSwitchPort';
export const AGENT_SITES_LIST_FIELD = 'sitesList';
export const AGENT_SITES_LIST_SORTABLE_FIELD = 'sitesListSortable';
export const AGENT_GEO_ISP_PROVIDER_FIELD = 'geoISP.provider';
export const AGENT_GEO_ISP_ISO_CODE_FIELD = 'geoISP.isoCode';
export const AGENT_GEO_ISP_SUB_DIVISION_ISO_CODE_FIELD = 'geoISP.subdivisionIsoCode';
export const AGENT_GEO_ISP_CITY_FIELD = 'geoISP.city';
export const AGENT_GEO_ISP_SUBDIVISION_FIELD = 'geoISP.subdivision';
export const AGENT_GEO_ISP_COUNTRY_FIELD = 'geoISP.country';
export const AGENT_GEO_ISP_POSTAL_FIELD = 'geoISP.postal';
export const AGENT_GEO_ISP_LATITUDE_FIELD = 'geoISP.latitude';
export const AGENT_GEO_ISP_LONGITUDE_FIELD = 'geoISP.longitude';
export const AGENT_GEO_ISP_NETWORK_FIELD = 'geoISP.network';
export const AGENT_ASN_FIELD = 'geoISP.asn';
export const AGENT_PUBLIC_IP_FIELD = 'publicIp';
export const AGENT_TEST_COUNT_FIELD = 'testCount';
// Location of test count when using the V3 api
export const AGENT_TEST_COUNT_V3_FIELD = 'system.serviceTestCount';
export const AGENT_TEST_COUNT_DISPLAY_FIELD = 'testCountDisplay';
export const AGENT_IS_AGENT_OVER_TEST_LIMIT_FIELD = 'isAgentOverTestLimit';
export const AGENT_CREATED_AT_FIELD = 'createdAt';
export const AGENT_LAST_SEEN_AT_FIELD = 'lastSeenAt';
export const AGENT_LAST_VERSION_CHANGE_FIELD = 'lastVersionChange';
export const AGENT_BEACONS_TRANSLATED_FIELD = 'translatedSEMBeacons';
export const AGENT_IS_FLEXXON_CARD = 'isFlexxonCard';
export const AGENT_VITALS_FIELD = 'vitals';
export const AGENT_VITALS_POE_VOLTAGE = `${AGENT_VITALS_FIELD}.poe_voltage`;
export const AGENT_VITALS_SERIAL_NUMBER = `${AGENT_VITALS_FIELD}.serial_number`;
export const AGENT_VITALS_APP_UPTIME = `${AGENT_VITALS_FIELD}.app_uptime`;
export const AGENT_VITALS_SYS_UPTIME = `${AGENT_VITALS_FIELD}.sys_uptime`;
export const AGENT_VITALS_SWITCH_TYPE = `${AGENT_VITALS_FIELD}.swProto`;
export const AGENT_VITALS_SWITCH_NAME = `${AGENT_VITALS_FIELD}.swName`;
export const AGENT_VITALS_SWITCH_IP = `${AGENT_VITALS_FIELD}.swIp`;
export const AGENT_VITALS_SWITCH_PORT = `${AGENT_VITALS_FIELD}.swPort`;
export const AGENT_VITALS_SWITCH_VLAN = `${AGENT_VITALS_FIELD}.portVlan`;
export const AGENT_VITALS_BATTERY_VOLTAGE = `${AGENT_VITALS_FIELD}.batt_voltage`;
export const AGENT_CPU_LOAD = 'cpu_load';
export const AGENT_VITALS_CPU_LOAD = `${AGENT_VITALS_FIELD}.${AGENT_CPU_LOAD}`;
export const AGENT_MEMORY_USED_PERCENT = 'mem_used_percent';
export const AGENT_VITALS_MEMORY_USED_PERCENT = `${AGENT_VITALS_FIELD}.${AGENT_MEMORY_USED_PERCENT}`;
export const AGENT_SD_LIFE_REMAINING = 'sd_life_remaining';
export const AGENT_VITALS_SD_LIFE_REMAINING = `${AGENT_VITALS_FIELD}.${AGENT_SD_LIFE_REMAINING}`;
export const AGENT_VITALS_SD_GOOD_BLOCK_RATIO = `${AGENT_VITALS_FIELD}.sd_good_block_ratio`;
export const AGENT_SD_MAX_ERASE_COUNT = 'sd_max_erase_count';
export const AGENT_VITALS_SD_MAX_ERASE_COUNT = `${AGENT_VITALS_FIELD}.${AGENT_SD_MAX_ERASE_COUNT}`;
export const AGENT_SD_AVG_ERASE_COUNT = 'sd_avg_erase_count';
export const AGENT_VITALS_SD_AVG_ERASE_COUNT = `${AGENT_VITALS_FIELD}.${AGENT_SD_AVG_ERASE_COUNT}`;
export const AGENT_TEMPERATURE = 'temperature';
export const AGENT_VITALS_TEMPERATURE = `${AGENT_VITALS_FIELD}.${AGENT_TEMPERATURE}`;
export const AGENT_VITALS_WIFI_MAC = `${AGENT_VITALS_FIELD}.wifi_mac`;
export const AGENT_TX_BUDGET_MB = 'tx_budget_mb';
export const AGENT_VITALS_TX_BUDGET_MB = `${AGENT_VITALS_FIELD}.${AGENT_TX_BUDGET_MB}`;
export const AGENT_TX_BUDGET_USED = 'tx_budget_used_percent';
export const AGENT_VITALS_TX_BUDGET_USED = `${AGENT_VITALS_FIELD}.${AGENT_TX_BUDGET_USED}`;
export const AGENT_TX_BUDGET_RESET_MINUTES = 'tx_budget_reset_minutes';
export const AGENT_VITALS_TX_BUDGET_RESET_MINUTES = `${AGENT_VITALS_FIELD}.${AGENT_TX_BUDGET_RESET_MINUTES}`;
export const AGENT_TX_TRANSFERRED_BYTES = 'tx_transferred_bytes';
export const AGENT_VITALS_TX_TRANSFERRED_BYTES = `${AGENT_VITALS_FIELD}.${AGENT_TX_TRANSFERRED_BYTES}`;
export const AGENT_RX_TRANSFERRED_BYTES = 'rx_transferred_bytes';
export const AGENT_VITALS_RX_TRANSFERRED_BYTES = `${AGENT_VITALS_FIELD}.${AGENT_RX_TRANSFERRED_BYTES}`;
export const AGENT_CERT_VALID_AFTER = 'certificateValidAfter';
export const AGENT_VITALS_CERT_VALID_AFTER = `${AGENT_VITALS_FIELD}.${AGENT_CERT_VALID_AFTER}`;
export const AGENT_CERT_VALID_BEFORE = 'certificateValidBefore';
export const AGENT_VITALS_CERT_VALID_BEFORE = `${AGENT_VITALS_FIELD}.${AGENT_CERT_VALID_BEFORE}`;

export const AGENT_BEACON_PACKET_CAPTURE_TRANSLATED_FIELD = 'translatedSEMPacketCapture';
export const AGENT_DISABLED_DUE_TO_LICENSE = 'disabledDueToLicense';
export const AGENT_UPDATE_ERROR = 'updateError';

export const AGENT_WEB_PROXY_DEFAULT_PROXY_OPTION = 'webProxyDefault';
export const AGENT_WEB_PROXY_MANUAL_PROXY_OPTION = 'webProxyManual';
export const AGENT_WEB_PROXY_AUTO_PROXY_OPTION = 'webProxyAuto';
export const AGENT_WEB_PROXY_OPTIONS = {
    [AGENT_WEB_PROXY_DEFAULT_PROXY_OPTION]: i18n._(t`Default Settings`),
    [AGENT_WEB_PROXY_MANUAL_PROXY_OPTION]: i18n._(t`Manual Proxy`),
    [AGENT_WEB_PROXY_AUTO_PROXY_OPTION]: i18n._(t`Proxy Auto-Configuration`),
};

export const AGENT_WIRED_AUTH_ENABLED = 'wiredAuthentication';
export const AGENT_WIRED_AUTH_GLOBAL = 'wiredAuthenticationGlobal';

export const AGENT_WEB_PROXY_FIELD = 'webProxy';
export const AGENT_WEB_PROXY_USE_DEFAULT = `${AGENT_WEB_PROXY_FIELD}.useDefault`;
export const AGENT_WEB_PROXY_PORT = `${AGENT_WEB_PROXY_FIELD}.webProxyPort`;
export const AGENT_WEB_PROXY_ADDRESS = `${AGENT_WEB_PROXY_FIELD}.webProxyAddress`;
export const AGENT_WEB_PROXY_AUTOCONFIG_URL = `${AGENT_WEB_PROXY_FIELD}.webProxyAutoconfigUrl`;
export const AGENT_WEB_PROXY_ENCRYPTED_USERNAME = `${AGENT_WEB_PROXY_FIELD}.encryptedWebProxyUsername`;
export const AGENT_WEB_PROXY_ENCRYPTED_USERNAME_VALUE = `${AGENT_WEB_PROXY_FIELD}.encryptedWebProxyUsername.value`;
export const AGENT_WEB_PROXY_ENCRYPTED_PASSWORD = `${AGENT_WEB_PROXY_FIELD}.encryptedWebProxyPassword`;
export const AGENT_WEB_PROXY_ENCRYPTED_PASSWORD_VALUE = `${AGENT_WEB_PROXY_FIELD}.encryptedWebProxyPassword.value`;
export const AGENT_WEB_PROXY_OVERRIDDEN = `${AGENT_WEB_PROXY_FIELD}.overridden`;
export const AGENT_WEB_PROXY_ENABLED = `${AGENT_WEB_PROXY_FIELD}.enabled`;
export const AGENT_BULK_EDIT_TAGS_FIELD = 'tags';
export const GLOBAL_AGENT_SETTINGS_FIELD = 'globalAgentSettings';

export const AGENT_BTT_USER_DOMAIN_FIELD = 'bttUser.bttUserDomain';
export const AGENT_BTT_USERNAME_FIELD = 'bttUser.bttUsername';
export const AGENT_BTT_USER_PASSWORD_FIELD = 'bttUser.bttUserPassword.value';

export const AGENT_BEACON_PACKETS_GLOBAL_OPTION = 'beaconPacketsGlobal';
export const AGENT_BEACON_PACKETS_ENABLED_OPTION = 'beaconPacketsEnabled';
export const AGENT_BEACON_PACKETS_DISABLED_OPTION = 'beaconPacketsDisabled';
export const AGENT_BEACON_PACKETS_GLOBAL_OPTION_TEXT = `${GLOBAL_AGENT_SETTINGS_FIELD}.globalOptionText`;
export const AGENT_BEACON_PACKETS_OPTIONS = {
    [AGENT_BEACON_PACKETS_ENABLED_OPTION]: i18n._(t`Enable for this nPoint`),
    [AGENT_BEACON_PACKETS_DISABLED_OPTION]: i18n._(t`Disable for this nPoint`),
};

export const CRYPTO_CONF_FIELD = 'crypto';
export const CRYPTO_CONF_POLICY_FIELD = `${CRYPTO_CONF_FIELD}.policy`;
export const CRYPTO_CONF_MODULES_FIELD = `${CRYPTO_CONF_FIELD}.modules`;

export const CRYPTO_POLICY_OPTIONS = Enum.proxy({
    DEFAULT_: 'Using DEFAULT Policy',
    LEGACY_: 'Using LEGACY Policy',
    getDefault: () => t`DEFAULT`,
});

export const AGENT_BEACON_PACKETS_FIELD = 'beaconPackets';
export const AGENT_BEACON_VIRTUAL_INTERFACES_FIELD = 'virtualInterfaces';
export const AGENT_BEACON_VIRTUAL_INTERFACES_WIRED_FIELD = `${AGENT_BEACON_VIRTUAL_INTERFACES_FIELD}.wired`;
export const AGENT_BEACON_VIRTUAL_INTERFACES_WIRED_OVERRIDDEN_FIELD = `${AGENT_BEACON_VIRTUAL_INTERFACES_WIRED_FIELD}.overridden`;
export const AGENT_BEACON_VIRTUAL_INTERFACES_WIRED_ENABLED_FIELD = `${AGENT_BEACON_VIRTUAL_INTERFACES_WIRED_FIELD}.enabled`;
export const AGENT_BEACON_VIRTUAL_INTERFACES_WIRED_TYPE_FIELD = `${AGENT_BEACON_VIRTUAL_INTERFACES_WIRED_FIELD}.type`;
export const AGENT_BEACON_VIRTUAL_INTERFACES_WIRED_NUMBER_FIELD = `${AGENT_BEACON_VIRTUAL_INTERFACES_WIRED_FIELD}.number`;
export const AGENT_BEACON_VIRTUAL_INTERFACES_WIRELESS_FIELD = `${AGENT_BEACON_VIRTUAL_INTERFACES_FIELD}.wireless`;
export const AGENT_BEACON_VIRTUAL_INTERFACES_WIRELESS_OVERRIDDEN_FIELD = `${AGENT_BEACON_VIRTUAL_INTERFACES_WIRELESS_FIELD}.overridden`;
export const AGENT_BEACON_VIRTUAL_INTERFACES_WIRELESS_ENABLED_FIELD = `${AGENT_BEACON_VIRTUAL_INTERFACES_WIRELESS_FIELD}.enabled`;
export const AGENT_BEACON_VIRTUAL_INTERFACES_WIRELESS_TYPE_FIELD = `${AGENT_BEACON_VIRTUAL_INTERFACES_WIRELESS_FIELD}.type`;
export const AGENT_BEACON_VIRTUAL_INTERFACES_WIRELESS_NUMBER_FIELD = `${AGENT_BEACON_VIRTUAL_INTERFACES_WIRELESS_FIELD}.number`;
export const AGENT_BEACON_PACKET_CAPTURE = `smartEdge.packetCapture`;

export const AGENT_BEACON_PACKETS_INTERFACES_GLOBAL_OPTION = `globalInterfaces`;

export const AGENT_WIFI_DISABLED_OPTION = 'wifiDisabled';
export const AGENT_WIFI_MULTI_SSID_OPTION = 'wifiMulti';
export const AGENT_WIFI_SINGLE_SSID_OPTION = 'wifiSingle';
export const AGENT_WIFI_OPTIONS = {
    [AGENT_WIFI_DISABLED_OPTION]: i18n._(t`Disabled`),
    [AGENT_WIFI_MULTI_SSID_OPTION]: i18n._(t`Multiple SSID Testing`),
    [AGENT_WIFI_SINGLE_SSID_OPTION]: i18n._(t`Single SSID Testing`),
};
export const AGENT_WIFI_DEFAULT_OPTION = 'wifiDefault';
export const AGENT_WIRED_DEFAULT_OPTION = 'wiredDefault';

export const AGENT_CERTIFICATE_FIELD = 'certificates';
export const AGENT_CERTIFICATE_USAGE_FIELD = 'certificateUsage';
export const AGENT_CERTIFICATE_NAME_FIELD = 'name';
export const AGENT_CERTIFICATE_DESCRIPTION_FIELD = 'description';

export const ID_FIELD = '_id';

export const AGENT_LIST_STATE_FIELD = 'state';
export const AGENT_LIST_VERSION_FIELD = 'version';
export const AGENT_LIST_INTERNAL_IP_FIELD = 'system.internalIP';
export const AGENT_LIST_EXTERNAL_IP_FIELD = 'system.externalIP';

// Non DB fields
export const AGENT_SCREEN_FIELD = `screenFields`;
export const AGENT_WEB_PROXY_SELECTION_FIELD = `${AGENT_SCREEN_FIELD}.webProxySelection`;
export const AGENT_BEACON_PACKETS_SELECTION_FIELD = `${AGENT_SCREEN_FIELD}.beaconPacketsSelection`;
export const AGENT_BEACON_PACKETS_WIRED_SELECTION_FIELD = `${AGENT_SCREEN_FIELD}.beaconPacketsWiredSelection`;
export const AGENT_BEACON_PACKETS_WIRELESS_SELECTION_FIELD = `${AGENT_SCREEN_FIELD}.beaconPacketsWirelessSelection`;
export const AGENT_WIFI_SELECTION_FIELD = `${AGENT_SCREEN_FIELD}.wifiSelection`;

export const AGENT_BEACON_PACKETS_GLOBAL_WIRED_OPTION_TEXT = `${GLOBAL_AGENT_SETTINGS_FIELD}.globalWiredOptionText`;
export const AGENT_BEACON_PACKETS_GLOBAL_WIRELESS_OPTION_TEXT = `${GLOBAL_AGENT_SETTINGS_FIELD}.globalWirelessOptionText`;

export const AGENT_EVENT_TEST_TIME_FIELD = 'testTime';
export const AGENT_EVENT_IP_FIELD = 'ip_address';
export const AGENT_EVENT_SEVERITY_FIELD = 'severity';
export const AGENT_EVENT_TYPE_FIELD = 'event_type';
export const AGENT_EVENT_CAUSE_FIELD = 'cause';

export const AGENT_UPDATE_ACTION_STATUSES = {
    [AGENT_STATUS_ENABLING]: 'enabled',
    [AGENT_STATUS_DISABLED]: 'disabled',
    [AGENT_STATUS_UPDATE]: 'updated',
    [AGENT_STATUS_RESTART]: 'restarted',
};

export const DBM = 'dBm';

export const AGENT_2K_TEST_LIMIT = 100;
export const AGENT_3K_TEST_LIMIT = 300;
export const AGENT_GLOBAL_TEST_LIMIT = 25;

export const AGENT_HARDWARE_2K_MODEL = 'NP-2000H';
export const AGENT_HARDWARE_3K_MODEL = 'NP-3000H';
export const AGENT_HARDWARE_EDGE_SENSOR_MODEL = 'NP-EDGE-H';
export const AGENT_VIRTUAL_2K_MODEL = 'NP-2000V';
export const AGENT_VIRTUAL_3K_MODEL = 'NP-3000V';
export const AGENT_VIRTUAL_290_MODEL = 'NP-EDGE-V';
export const AGENT_GLOBAL_MODEL = 'NP-3000G';

export const AGENT_OS_WINDOWS = 'windows';
export const AGENT_OS_LINUX = 'linux';
export const AGENT_OS_MAC = 'macOS';
export const AGENT_OS_DOCKER_MAC = 'dockerMac';

export const AGENT_HOST_HTTP_CLIENT_CURL = 'curl';
export const AGENT_HOST_HTTP_CLIENT_WGET = 'wget';

export const AGENT_TYPE_VIRTUAL = 'V';
export const AGENT_TYPE_GLOBAL = 'G';
export const AGENT_TYPE_VBCS = 'B';

export const ADAPTER_TYPE_WIRELESS = 'wireless';

export const AGENTS_FUNCTION_NAME = AdminPages.Agents;

export const AGENT_REFRESH_INTERVAL = 30000;

export const AGENT_MAX_GLOBAL_TESTS = 25;

export const AGENT_DATA_SOURCE_SEARCH_FIELDS = [
    AGENT_NAME_FIELD,
    AGENT_TRANSLATED_TYPE_FIELD,
    AGENT_MODEL_SHORT_DISPLAY_FIELD,
    AGENT_TAGS_DISPLAY_FIELD,
    AGENT_STATUS_FIELD,
    AGENT_NETWORK_HOSTNAME_FIELD,
    AGENT_TRANSLATED_WEB_PROXY_FIELD,
    AGENT_NETWORK_IPV4_LOCAL_FIELD,
    AGENT_NETWORK_IPV6_LOCAL_FIELD,
    AGENT_NETWORK_IP_EXTERNAL_FIELD,
    AGENT_NETWORK_MAC_FIELD,
    AGENT_SERIAL_NUMBER,
    AGENT_NEAREST_SWITCH_FIELD,
    AGENT_NEAREST_SWITCH_IP_FIELD,
    AGENT_NEAREST_SWITCH_PORT_FIELD,
    AGENT_SITES_LIST_SORTABLE_FIELD,
    AGENT_WIFI_SSID_FIELD,
    AGENT_NETWORK_WIFI_MAC_FIELD,
    AGENT_GEO_ISP_PROVIDER_FIELD,
    AGENT_GEO_ISP_ISO_CODE_FIELD,
    AGENT_GEO_ISP_SUB_DIVISION_ISO_CODE_FIELD,
    AGENT_GEO_ISP_CITY_FIELD,
    AGENT_GEO_ISP_SUBDIVISION_FIELD,
    AGENT_GEO_ISP_COUNTRY_FIELD,
    AGENT_GEO_ISP_POSTAL_FIELD,
    AGENT_GEO_ISP_LATITUDE_FIELD,
    AGENT_GEO_ISP_LONGITUDE_FIELD,
    AGENT_GEO_ISP_NETWORK_FIELD,
    AGENT_MAX_GLOBAL_TESTS,
];

export const AGENT_DATA_SOURCE = {
    url: '/query/admin/agents',
    crudUrl: '/ipm/v1/admin/agents',
    totalProperty: 'count',
    dataProperty: 'data',
    params: {
        searchFields: AGENT_DATA_SOURCE_SEARCH_FIELDS,
    },
};

export const AGENT_WIFI_PERMACADDR_ENABLED = 'isWirelessPerMacAddrEnabled';
export const AGENT_WIFI_STATIC_IP_ENABLED = `isWirelessStaticIpEnabled`;
export const AGENT_WIFI_STATIC_IP_FIELD = `wirelessStaticIp`;
export const AGENT_WIFI_STATIC_IP_ADDRESS = `${AGENT_WIFI_STATIC_IP_FIELD}.ipaddress`;
export const AGENT_WIFI_STATIC_IP_MASK = `${AGENT_WIFI_STATIC_IP_FIELD}.mask`;
export const AGENT_WIFI_STATIC_IP_GATEWAY = `${AGENT_WIFI_STATIC_IP_FIELD}.gateway`;
export const AGENT_WIFI_STATIC_IP_DNS = `${AGENT_WIFI_STATIC_IP_FIELD}.dns`;
